// extracted by mini-css-extract-plugin
export var backgroundImage = "_v-1";
export var container = "_v-0";
export var title = "_v-2";